import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MainLayout from './MainLayout';

const DataFittingHistory = () => {
  const [history, setHistory] = useState([]);
  const token = localStorage.getItem('token');

  useEffect(()=> {
    const load = async () => {
      const res = await axios.get('https://openmkm.vidyayug.com/api/data-fitting/history', {
        headers: { Authorization: token }
      });
      setHistory(res.data.history || []);
    };
    load().catch(console.error);
  }, [token]);

  return (
    <MainLayout>
      <div style={{ padding: 20 }}>
        <h2>Data Fitting History</h2>
        {history.length === 0 ? <p>No fits yet.</p> : (
          <div>
            {history.map(h => (
              <div key={h.project_id} style={{ border: '1px solid #eee', padding: 12, marginBottom: 10 }}>
                <strong>Project:</strong> {h.project_id}
                <div><strong>Files:</strong> {h.files.join(', ')}</div>
                <div><strong>Fit:</strong>
                  <pre style={{ background:'#fafafa', padding:8 }}>{JSON.stringify(h.fit, null, 2)}</pre>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default DataFittingHistory;
